export default function AccessSection() {
  return (
    <section id="access" className="py-20 md:py-32 px-6 bg-white relative overflow-hidden">
      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulance type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-7xl mx-auto relative">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest-800 mb-4">
            アクセス・周辺案内
          </h2>
          <div className="w-24 h-1 bg-gold-600 mx-auto"></div>
        </div>

        <div className="max-w-2xl mx-auto">
          {/* Access Info */}
          <div className="space-y-8">
            <div>
              <h3 className="font-serif text-2xl font-semibold text-forest-800 mb-6">
                アクセス
              </h3>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gold-100 rounded-full flex-shrink-0">
                    <i className="ri-map-pin-fill text-gold-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-forest-800 mb-1 text-base">住所</p>
                    <p className="text-gray-700 text-sm">
                      〒667-1127
                      <br />
                      兵庫県養父市大久保425
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gold-100 rounded-full flex-shrink-0">
                    <i className="ri-phone-fill text-gold-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-forest-800 mb-1 text-base">電話番号</p>
                    <a
                      href="tel:079-667-8119"
                      className="text-gray-700 hover:text-gold-600 transition-colors text-sm cursor-pointer"
                    >
                      079-667-8119
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gold-100 rounded-full flex-shrink-0">
                    <i className="ri-printer-fill text-gold-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-forest-800 mb-1 text-base">FAX</p>
                    <p className="text-gray-700 text-sm">079-667-8158</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gold-100 rounded-full flex-shrink-0">
                    <i className="ri-time-fill text-gold-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-forest-800 mb-1 text-base">
                      チェックイン・アウト
                    </p>
                    <p className="text-gray-700 text-sm">
                      チェックイン：15:00〜19:00
                      <br />
                      チェックアウト：10:00
                    </p>
                  </div>
                </div>
              </div>

              <a
                href="https://www.google.com/maps/search/?api=1&query=兵庫県養父市大久保425"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center px-8 py-3.5 bg-gold-600 text-white text-base font-medium rounded-full hover:bg-gold-700 transition-colors mt-8 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-map-2-fill mr-2"></i>
                Googleマップで見る
              </a>
            </div>

            {/* Surrounding Info */}
            <div className="bg-forest-50 rounded-2xl p-6">
              <h4 className="font-serif text-xl font-semibold text-forest-800 mb-4">
                周辺案内
              </h4>
              <p className="text-gray-700 leading-relaxed text-sm mb-4">
                ハチ高原の豊かな自然に囲まれた立地で、四季折々の風景をお楽しみいただけます。
              </p>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-gold-600 mr-2 mt-1"></i>
                  <span>スキー場まで徒歩圏内</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-gold-600 mr-2 mt-1"></i>
                  <span>自然散策・ハイキングコース</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-gold-600 mr-2 mt-1"></i>
                  <span>登山・トレッキング</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-gold-600 mr-2 mt-1"></i>
                  <span>四季の風景撮影スポット</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}